import { track } from '@bnnvara/analytics/src/track';
import PropTypes from 'prop-types';
import React from 'react';

import { Icon } from '../Icon';
import * as S from './styled';

export const CommentButton = ({ detailPageUrl }) => (
  <S.CommentButton
    href={`${detailPageUrl}#reageren`}
    target="_blank"
    rel="noopener noreferrer"
    onClick={() => {
      track('video-player-comment', 'click', 'link to comments');
    }}
  >
    <Icon icon="comment" size="25" />
  </S.CommentButton>
);

CommentButton.propTypes = {
  detailPageUrl: PropTypes.string.isRequired,
};
